var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDisplayed)?_c('iw-input-checkbox',{staticClass:"field",attrs:{"input-label":_vm.$t('lift'),"name":"has-elevator"},model:{value:(_vm.hasElevator),callback:function ($$v) {_vm.hasElevator=$$v},expression:"hasElevator"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }